import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { tag_returndata } from 'src/types/tag_returndata';
import { Router } from '@angular/router';
import { cTag, tag } from 'src/types/tag';
import {MessageService} from 'primeng/api';

import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';


@Component({
  selector: 'app-tagedit',
  templateUrl: './tagedit.component.html',
  styleUrls: ['./tagedit.component.css']
})

export class TageditComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Tag: cTag;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;
  tagNameValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    this.Tag = {
      id: null,
      tagId: null,
      name: "",
      colour: "",
      disabled: false,
      venueId: this.VenueID,
      system: false
    }



  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("TAGS", user)){
          this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "tag/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as tag_returndata)
              if (this.httpResponse.succeeded)
              {
                this.Tag = {
                  id: (this.httpResponse.data as cTag).id,
                  tagId: (this.httpResponse.data as cTag).tagId,
                  name: (this.httpResponse.data as cTag).name,
                  venueId: (this.httpResponse.data as cTag).venueId,
                  disabled: (this.httpResponse.data as cTag).disabled,
                  colour: (this.httpResponse.data as cTag).colour,
                  system: (this.httpResponse.data as cTag).system
                };
      
                this.pageReady = true;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
        }

        this.CompletedLoading = true;


      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });



  }

  updateData()
  {
    if(this.DoValidCheck())
      {
      if(this.id=="0")
      {
        this.http.post<tag>(bmxurl + "/tag", this.Tag).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Tag successfully created'});
            this.router.navigateByUrl("/tag");
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
        })
      }
      else
      {
        this.Tag.disabled = false;

        this.http.put<tag>(bmxurl + "/tag", this.Tag).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Tag successfully updated'});
            this.router.navigateByUrl("/tag");
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }
  }

  returnToList()
  {
    this.router.navigateByUrl("/tag");
  }

  DoValidCheck(){
    let AllValid = true;

    if(this.Tag.name == null || this.Tag.name == "")
    {
      AllValid = false;
      this.tagNameValid = false;
    }
    else
    {
      this.tagNameValid = true;
    }

    return AllValid;
  }
}
